import React, { useState } from "react";
import { Collapsible, CollapsibleTrigger, CollapsibleContent, HorizontalKeyValuePair } from "@kuda/ui";
import { ChevronDownIcon } from "@kuda/ui/icons";
import ColoredAvatar from "./hooks/colorAvatar";

const SecretDetailsCard = ({
  name,
  timeAgo,
  clusterName,
  env,
  createdBy,
  secretName,
  project,
  store,
  recentViewers = [],
}) => {
  const [open, setOpen] = useState(false);

  // De-duplicate by viewer name, keep only the most recent handful — the
  // backend already caps and sorts these, this is just a display safeguard.
  const viewerNames = [...new Set(recentViewers.map((e) => e.viewer).filter(Boolean))].slice(0, 5);

  const rows = [
    ["Cluster name", clusterName],
    ["Created by", createdBy || "Devops"],
    ["Secret name", secretName],
    ["Environment", env],
    ["Team", project],
    ["Store name", store === "test" ? "AWS Secret Manager" : store],
    ["Recently viewed by", viewerNames.length ? viewerNames.join(", ") : "No recent views"],
  ];

  return (
    <div className="rounded-lg border border-color-border-secondary" style={{ width: "58rem" }}>
      <Collapsible open={open} onOpenChange={setOpen} className="group">
        <CollapsibleTrigger asChild>
          <button type="button" className="flex items-center justify-between w-full p-4 text-left hover:bg-color-bg-secondary rounded-lg">
            <div className="flex items-center gap-2">
              <span>Last updated by</span>
              <ColoredAvatar name={name || "Devops"} size={20} />
              <span><strong>{name || "Devops"}</strong> {timeAgo || "some time ago"}</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-color-text-brand-primary-default">Secret Details</span>
              <ChevronDownIcon className="size-4 transition-transform group-data-[state=open]:rotate-180" />
            </div>
          </button>
        </CollapsibleTrigger>
        <CollapsibleContent>
          <div className="flex flex-col gap-2 px-4 pb-4" style={{ maxWidth: 400 }}>
            {rows.map(([label, value]) => (
              <HorizontalKeyValuePair key={label} label={label} value={value || "N/A"} size="sm" />
            ))}
          </div>
        </CollapsibleContent>
      </Collapsible>
    </div>
  );
};

export default SecretDetailsCard;
